import { z } from 'zod';
import { templateAdvanceLogicV1Schema } from './advance-logic';
import { templateNamedWidgetSchema } from './base';
import { fieldLayoutShape } from './field-layout';
import { TEXT_COLOR_VALUES, templateTextColorSchema } from './typography';

export const templateNumberSelectSchema = templateNamedWidgetSchema.extend({
  type: z.literal('numberSelect'),
  isRequired: z.boolean(),
  labelColor: templateTextColorSchema.default(TEXT_COLOR_VALUES.BLACK),
  value: z.string(),
  ...fieldLayoutShape,
  advanceLogics: templateAdvanceLogicV1Schema,
});

export type TemplateNumberSelectV1 = z.infer<typeof templateNumberSelectSchema>;
